import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload.component';
import { NgxMaskModule } from 'ngx-mask';
import { ErrorMessageModule } from '@app/theme/error-message/error-message.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FileUploadModule as NG2FileUploadModule } from 'ng2-file-upload';
import { TextFieldModule } from '../text-field/text-field.module';
import { FileUploadInputComponent } from './file-upload-input/file-upload-input.component';
import { MaterialModule } from '@app/material/material.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [FileUploadComponent, FileUploadInputComponent],
  imports: [
    CommonModule,
    NgxMaskModule.forRoot(),
    ErrorMessageModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NG2FileUploadModule,
    TextFieldModule,
    MaterialModule,
    MatTooltipModule,
  ],
  exports: [FileUploadComponent, FileUploadInputComponent],
})
export class FileUploadModule {}
